/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-irregular-whitespace */
import Checkbox from '@carvana/ds-checkbox';
import React, { useEffect } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import styles from './consents.module.css';
import { usePaymentContext } from '../../../contexts/payment';
import type { PaymentSelectionBankAccount } from '../../../services/purchase-payments-api.types';

const getCheckboxText = (bankAccount: PaymentSelectionBankAccount | undefined) =>
  bankAccount?.accountMask
    ? `I have sufficient funds available to cover this amount due in my account ending ••••\u00A0${bankAccount.accountMask}`
    : undefined;

interface ConsentsProps {
  disableClickOnSufficientFundsCheckbox: boolean;
  hasCustomerConfirmedSufficientFunds: boolean;
  setHasCustomerConfirmedSufficientFunds: Dispatch<SetStateAction<boolean>>;
}

export const Consents = ({
  disableClickOnSufficientFundsCheckbox,
  hasCustomerConfirmedSufficientFunds,
  setHasCustomerConfirmedSufficientFunds
}: ConsentsProps) => {
  const {
    state: {
      paymentSummary: {
        purchasePaymentBreakdown: { amountDue },
        paymentSelection,
        consents
      }
    }
  } = usePaymentContext();

  const checkboxText = getCheckboxText(paymentSelection?.bankAccount);
  const shouldShowCheckbox =
    amountDue > 0 && paymentSelection?.selectionType === 'BankAccount' && !!checkboxText;

  useEffect(() => {
    if (!shouldShowCheckbox) {
      setHasCustomerConfirmedSufficientFunds(true);
    }
  }, [shouldShowCheckbox]);

  if (consents.length === 0 && !shouldShowCheckbox) {
    return null;
  }

  const onClick = () => {
    if (!disableClickOnSufficientFundsCheckbox) {
      setHasCustomerConfirmedSufficientFunds(value => !value);
    }
  };

  return (
    <div className={styles.container}>
      {shouldShowCheckbox && (
        <Checkbox
          size="small"
          label={checkboxText}
          checked={hasCustomerConfirmedSufficientFunds}
          onChange={onClick}
          data-analytics-id="pp_complete_purchase_pao_confirm_funds_checkbox"
        />
      )}

      {consents.map((consent, index) => (
        <div
          key={index}
          className={styles.consentText}
          dangerouslySetInnerHTML={{ __html: consent.html }}
        />
      ))}
    </div>
  );
};
